<template>
	<fieldset class="fieldset">
		<div class="form-row">
			<field-box name="intangible_asset[intangible_asset_type]" :label="$t('forms.intangible_asset_type')" type="select" :options="intangibleAssetTypeOptions" :disabled="disabled" :has-error="errors?.['intangible_asset.intangible_asset_type']?.length"/>
		</div>
	</fieldset>
</template>

<script>

import DefaultFieldBox from "@/components/form-fields/DefaultFieldBox.vue";
import FieldBox from "@/components/form-fields/FieldBox.vue";

export default {
	name: "PropertyIntangibleAssetFieldset",
	props: ['data', 'disabled', 'errors'],
	components: {
		DefaultFieldBox,
		FieldBox
	},
	computed: {
		intangibleAssetTypeOptions(){
			let options = [
				{
					value: '',
					title: this.$t('forms.choose')
				},
				{
					value: 'patent',
					title: this.$t('forms.intangible_asset_type_patent')
				},
				{
					value: 'license',
					title: this.$t('forms.intangible_asset_type_license')
				},
			];

			if(this.data){
				options.forEach(item => {
					if (item.value === this.data?.intangible_asset_type) {
						item.selected = true;
					}
				});
			}

			return options;
		}
	}
}
</script>

<style scoped lang="scss">
fieldset {
	margin: 0;
	padding: 0;
	margin-inline: 0;
	padding-block: 0;
	padding-inline: 0;
	border: none;
}


.form-row {
	margin-bottom: 15px;

	&:last-child {
		margin-bottom: 0;
	}

	&.two-columns {
		display: flex;
		justify-content: space-between;
		flex-direction: row;

		.field-box {
			width: calc(50% - 8px);
		}
	}
}

@media($mobileS) {
	.form-row {
		margin-bottom: 10px;

		&.two-columns {
			flex-direction: column;

			.field-box {
				width: 100%;
				margin-bottom: 10px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}

</style>